package com.klantenstop.web.pages.authentication.forgotPassword

import com.klantenstop.web.utils.MVI

interface ForgotPasswordContract : MVI<ForgotPasswordContract.State, ForgotPasswordContract.Intent, ForgotPasswordContract.Effect> {
    data class State(
        val emailAddress: String = "",
        val isLoading: Boolean = false,
        val showValidation: Boolean = false,
    ) {
        fun isValid(): Boolean {
            return emailAddress.isNotEmpty()
        }
    }

    sealed class Intent {
        data object SubmitForgotPassword : Intent()
        data class UpdateEmail(val value: String) : Intent()
    }

    sealed class Effect {
        // No navigation effect needed - user stays on page after success
    }
}

